// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container{
    padding: 20px 10px;
}

.main-heading{
    font-weight: 600 !important;
    font-size: 20px !important;
    margin-bottom: 4px;
    font-family: sans-serif;
    color: #373334;
}
.main-heading-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
.footer-main-container{
    background-color: #F3F2F0;
}`, "",{"version":3,"sources":["webpack://./src/pages/PrivacyPolicy/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[".content-container{\r\n    padding: 20px 10px;\r\n}\r\n\r\n.main-heading{\r\n    font-weight: 600 !important;\r\n    font-size: 20px !important;\r\n    margin-bottom: 4px;\r\n    font-family: sans-serif;\r\n    color: #373334;\r\n}\r\n.main-heading-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n.footer-main-container{\r\n    background-color: #F3F2F0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
